<template>
    <div class="bulk-history-container">
        <div v-if="!bulks" class="mt-2">
            <div class="table_div" style="width:100%;overflow-x:auto;overflow-y:hidden">
                <table class="BulkHistory_table">
                    <thead>
                    <tr class="BulkHistory_table_header">
                        <th>Created On</th>
                        <th>File Name</th>
                        <th>Bulk UUID</th>
                        <th>Started On</th>
                        <th>Finished On</th>

                        <th style="padding: 0;">
                            <table>
                                <tr>
                                    <td colspan="4">Count</td>
                                </tr>
                                <tr>
                                    <td style="width: 67px;padding: 10px;border-right: 1px solid #fff;">Total</td>
                                    <td style="width: 67px;padding: 10px;border-right: 1px solid #fff;">Sent</td>
                                    <td style="width: 67px;padding: 10px;border-right: 1px solid #fff;">Succ</td>
                                    <td style="width: 67px;padding: 10px;">Failed</td>
                                </tr>
                            </table>
                        </th>

                        <th>Status</th>
                        <th class="action">Action</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr class="line" v-for="(bulk, k) in bulks" :key="k">
                        <th style="">{{ formatDate(bulk.started_at) }}</th>
                        <th style="">{{bulk.src_file}}</th>
                        <th class="creadted_by" style="">
                            {{ bulk.bulk_uuid }}
                        </th>
                        <th class="method" style="">{{ formatDate(bulk.started_at) }}</th>
                        <th style="">{{ formatDate(bulk.started_at) }}</th>
                        <th style="padding: 0;">
                            <table>
                                <tr style="box-shadow: none;">
                                    <td style="width: 67px;padding: 10px;">{{ bulk.dest_count }}</td>
                                    <td style="width: 67px;padding: 10px;">{{ bulk.dest_sent }}</td>
                                    <td style="width: 67px;padding: 10px;">{{ bulk.dest_success }}</td>
                                    <td style="width: 67px;padding: 10px;">{{ bulk.dest_failed }}</td>
                                </tr>
                            </table>
                        </th>
                        <th style="">{{ bulk.status }}</th>
                        <th class="icon action" style="">
                            <primary-button v-if="bulk.status != 'completed' && bulk.status != 'stop'"
                                            @click.native="ActionHandler(bulk)"
                            >{{ bulk.status == 'initial' || bulk.status == 'hold' ? 'Run' : 'Hold' }}
                            </primary-button>
                        </th>
                    </tr>
                    </tbody>
                </table>
            </div>
            <div class="custom-row">
                <span class="filter_by">Show Per Page:</span>
                <div class="primary-input-container choose-type perPage">
                    <primary-select
                            type="text"
                            @input="changePerPage"
                            v-model="per_page" :is-cross="false"
                            class="choose-type perPage"
                            placeholder="Select"
                    >
                        <option :value="item" v-for="(item,key) in pages" :key="key">{{item}}</option>
                    </primary-select>
                </div>
                <pagination-component
                        @change-page="changePage($event)"
                        :page="Page"
                        :perPage="per_page"
                        :total="TotalPages"
                        :qnt="bulks.length"
                        class="bulk-history-pagination-box"
                />
            </div>
        </div>
        <div v-else class="text-center "style="margin-top: 124px">
            <h2 >No Result found</h2>
        </div>
    </div>
</template>

<script>
    import {format} from "date-fns";

    export default {
        components: {
            PrimaryButton: () => import("@/components/Buttons/PrimaryButton.vue"),
            PaginationComponent: () => import("@/components/Pagination.vue"),
            PrimarySelect: () => import("@/components/Inputs/PrimarySelect.vue"),
        },
        data: () => ({
            // showDropDown: false,
            // payments: [],
            // PerPage: null,
            // Total: null,
            // Searched: "",
            Page: 0,
            TotalPages: null,
            pages: [10, 20, 50, 100, 200],
            per_page: 10,
            bulks: []
        }),
        created() {
            this.GetHistory();
        },
        methods: {
            GetHistory() {
                this.$store
                    .dispatch('BulkHistory', {
                        order_by: 'started_at',
                        order_dir: 'desc',
                        per_page: this.per_page ? this.per_page : 10,
                        page: this.Page
                    })
                    .then(res => {
                        if (res.status == 200) {
                            const items = res.data.payload.items;
                            if (!items.length) {
                                this.$router.push({name: "company-admin-billing-add-payment"});
                                return;
                            }
                            this.bulks = items;
                            this.TotalPages = res.data.payload.total / res.data.payload.per_page;
                        }
                        console.log(res);
                        console.log(this.bulks);
                    });
            },
            formatDate(dateStr) {
                return format(dateStr, "YYYY:MM:DD HH:mm:ss");
            },
            ActionHandler(bulkItem) {
                if (bulkItem.status == 'hold' || bulkItem.status == 'initial') {
                    this.$store.dispatch('BulkRun', bulkItem.bulk_uuid)
                        .then(res => {
                            bulkItem.status = 'running';
                            this.$success("Success");
                        })
                }

                if (bulkItem.status == 'running') {
                    this.$store.dispatch('BulkHold', bulkItem.bulk_uuid)
                        .then(res => {
                            bulkItem.status = 'hold';
                            this.$success("Success");
                        })
                }
            },
            changePage(page) {
                this.Page = page;
                this.GetList();
            },
            changePerPage(e) {
                this.Page = 0;
                this.GetList();
            },
        },
    };
</script>

<style lang="scss" scoped>
    .bulk-history-container {
        padding-top: 20px;
    }

    .line {
        height: 60px;
    }

    .perPage {
        display: flex;
        width: 120px;
        display: inline-block;
    }

    .custom-row {
        width: 100%;
        display: flex;
        margin-top: 25px;

        span {
            margin-top: 7px;
            margin-right: 10px;
        }

        .bulk-history-pagination-box {
            flex: 1;
            width: auto;
            margin-top: 0;
        }
    }

    table.BulkHistory_table {
        width: 100%;

        th {
            text-align: center;
        }

        .action {
            width: 100px;
        }

        .method {
            text-transform: capitalize;
        }
    }

    table thead tr {
        background: linear-gradient(135deg, #51a3f3 0%, #51b5f3 100%);

        th {
            border-bottom-width: 2px;
            color: white;
            padding-left: 10px;
            vertical-align: bottom;
            border-bottom: 2px solid #dee2e6;
            border: 1px solid #dee2e6;
        }
    }

    table,
    tr {
        width: 100%;
        height: 44px;
        box-shadow: inset 0 -1px 0 0 #f0f1fa;
        -webkit-box-shadow: inset 0 -1px 0 0 #f0f1fa;
        -moz-box-shadow: inset 0 -1px 0 0 #f0f1fa;
        background-color: #ffffff;
    }

    table tr th {
        padding: 0px 10px 0 20px;
    }

    table {
        border-collapse: collapse;
    }

    .BulkHistory_table_header th {
        color: white;
        padding-left: 10px;
        border-bottom-width: 2px;
        vertical-align: bottom;
        border-bottom: 2px solid #dee2e6;
        border: 1px solid #dee2e6;
        padding: 0.75rem;
        text-align: center;
    }

    .BulkHistory_table_header th:first-child {
        width: 14%;
    }

    tbody th:first-child {
        padding-left: 35px;
        padding-right: 30px;
    }

    th {
        max-width: 250px;
    }

    tbody th {
        color: #212b36;
        font-weight: normal;
        font-family: "Helvetica Neue";
        font-size: 14px;
        line-height: 20px;
        padding: 15px 20px;
    }

    .buttons-wrapper {
        width: 100%;
        justify-content: flex-end;
    }

    @media (max-width: 891px) {
        .right-wrapprr {
            width: 100% !important;
        }
    }

    @media (max-width: 767px) {
        .add-navigation {
            display: block !important;
            height: auto !important;
        }
        .custom-row {
            width: 100% !important;
        }
        .buttons-wrapper {
            width: 100%;
            justify-content: flex-start !important;
        }
    }

    @media (max-width: 600px) {
        .custom-row {
            display: block !important;
        }

        .buttons-wrapper {
            width: 100% !important;
        }
        .col-lg-6.col-md-7.col-xs-12 {
            margin-top: 15px;
        }
    }

    .add-navigation {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        height: 40px;
        width: 100%;
        margin-top: 20px;
        margin-bottom: 20px;

        .search-input {
            height: 40px;
            width: 345px;
            background-color: #ffffff;
        }

        .primary-button {
            height: 40px;
            width: 145px;
        }
    }

    .buttons-wrapper {
        display: flex;
        align-items: center;
        width: 100%;

        .secondary-button {
            height: 40px;
            width: 90px;
            margin-right: 15px;
        }
    }

    .BulkHistory_table_popup {
        text-align: right;
        position: relative;
        float: right;

        .popup_cta {
            cursor: pointer;
            color: #55616e;
        }
    }

    .popup_content {
        display: none;
    }

    .popup_cta {
        cursor: pointer;
    }

    .Invoice_price {
        font-family: "Helvetica Neue";
        padding: 13px 0 12px 0;
        color: #000000;
        font-weight: bold;
    }

    th.icon {
        padding: 0;
    }

    .BulkHistory_table_popup {
        vertical-align: center;
    }

    .BulkHistory_table_popup.active .popup_content {
        display: block;
        position: absolute;
        right: 0;
        width: 240px;
        border-radius: 4px;
        background-color: #ffffff;
        box-shadow: 0 10px 40px 0 rgba(0, 0, 0, 0.1);
        padding-left: 0;
        list-style-type: none;
        text-align: left;
    }

    .BulkHistory_table_popup.active .popup_content a {
        color: #55616e;
        font-size: 16px;
        line-height: 20px;
        text-decoration: none;
        font-family: "Helvetica Neue";
        padding: 10px 15px;
        display: inline-block;
    }

    .popup_image {
        width: 30px;
        height: 30px;
        border-radius: 50%;
        vertical-align: middle;
        margin-right: 8px;
        float: left;
    }

    th.user_active:after {
        content: "";
        height: 10px;
        width: 10px;
        background-color: #24e2b8;
        position: absolute;
        border-radius: 50%;
        left: 12px;
        top: 25px;
    }

    th.user_active {
        text-align: left;
        position: relative;
        padding-left: 32px;
    }

    @media (max-width: 1350px) {
        table.BulkHistory_table {
            width: 1000px;
        }
    }

    .table_div::-webkit-scrollbar {
        width: 8px;
        height: 8px;
        background-color: #f5f5f5;
    }

    .table_div::-webkit-scrollbar-thumb {
        border-radius: 10px;
        background-image: -webkit-gradient(
                        linear,
                        left bottom,
                        left top,
                        color-stop(0.44, #51a3f3),
                        color-stop(0.72, #51a3f3),
                        color-stop(0.86, #51a3f3)
        );
    }
</style>

